//https://aidu-api-dev.vizlabs.ai/contact/create
//dùng fetch để gọi api
import { Contact } from '../interface/contact';

export const createContact = async (contact: Contact) => {
  try {
    const response = await fetch('https://aidu-api-dev.vizlabs.ai/contact/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contact),
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error creating contact:', error);
    throw error; // Re-throw để component gọi hàm này có thể xử lý lỗi
  }
};
